import type from './constants';

export default {
    saveQuotationInfo: (params) => {
        return {
            type: type.SAVE_QUOTATION_INFO,
            params,
        }
    },
    saveUpdateParams: (params) => {
        return {
            type: type.SAVE_UPDATE_PARAMS,
            params,
        }
    }
};


// WEBPACK FOOTER //
// ./src/components/quotation/store/actions.js